module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "event-item",
    class: _vm.cssClasses,
    on: {
      "click": function($event) {
        return _vm.$emit('click', _vm.event, $event)
      }
    }
  }, [(_vm.showTitle) ? _vm._t("default", [_vm._v("\n        Def: " + _vm._s(_vm.event.title) + "\n    ")], {
    "event": _vm.event
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-19403a96","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/fullCalendar/fc/eventCard.vue
// module id = 533
// module chunks = 1 2 3 4 5 6 7 8